import http from '@/http'
import { IMAGE_TYPES, VIDEO_TYPES } from '@/lib/constants'
import EventEmitter from 'events'

function isPreviewableImage(fileName) {
  const format = new RegExp('([^w]+(\\.(' + IMAGE_TYPES.join('|') + '))$)', 'i')
  return format.test(fileName)
}

function isPreviewableVideo(fileName) {
  const format = new RegExp('([^w]+(\\.(' + VIDEO_TYPES.join('|') + '))$)', 'i')
  return format.test(fileName)
}

function isPreviewablePdf(fileName) {
  const format = new RegExp('([^w]+(\\.(pdf))$)', 'i')
  return format.test(fileName)
}

export default class DownloadPrivateFile extends EventEmitter {
  constructor({
    url,
    fileName
  } = {}) {
    super()
    http.get(url, { responseType: 'blob' }).then(response => {
      this.fileName = fileName
      let previewableType
      if (isPreviewableImage(fileName)) {
        previewableType = 'image'
        this.downloadData = new Blob([response.data])
      } else if (isPreviewableVideo(fileName)) {
        previewableType = 'video'
        this.downloadData = new Blob([response.data])
      } else if (isPreviewablePdf(fileName)) {
        previewableType = 'pdf'
        this.downloadData = new Blob([response.data], { type: 'application/pdf' })
      } else {
        this.downloadData = new Blob([response.data])
      }
      this.emit('download', {
        data: this.downloadData,
        previewableType: previewableType
      })
    }).catch(() => {
      this.emit('error')
    })
  }

  download() {
    const virtualLink = document.createElement('a')
    virtualLink.href = URL.createObjectURL(this.downloadData)
    virtualLink.download = this.fileName
    virtualLink.click()
    URL.revokeObjectURL(virtualLink)
  }
}
